import { useState } from 'react';
import useApi from '@/lib/api/useApi';
import useIsPortfolioReadonly from '../../useIsPortfolioReadonly';
import { type ChallengeSummary } from '@/lib/types';

const useMarkCoachCommentsAsReadOnLoad = (
  challenge: ChallengeSummary,
  loading: boolean,
): void => {
  const api = useApi();

  const portfolioIsReadonly = useIsPortfolioReadonly();
  const [markedAsRead, setMarkedAsRead] = useState(false);

  const markCoachCommentsAsRead = (): void => {
    setMarkedAsRead(true);

    api.post(
      `challenge-portfolio/challenges/${challenge.id}/coach-comments/read`,
    );
  };

  if (!loading && !markedAsRead && !portfolioIsReadonly) {
    markCoachCommentsAsRead();
  }
};

export default useMarkCoachCommentsAsReadOnLoad;
